import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetAliveQuery } from '../alive/aliveEndpoints';

/** Props for `AuthLayout`. */
export interface AuthLayoutProps {
  /** The card's content. */
  children: ReactNode;
  /** Links shown under the card, such as "Create one" or "Back to sign in". */
  footer?: ReactNode;
}

/**
 * The public sign-in pages' frame (QZ-D28, QZ-D47): the GPS Quiz hills, the app name with its
 * environment badge, and one card. The badge says which pool you are signing in to; it
 * appears once `/alive` answers (QZ-D10 keeps the environment out of `config.json`).
 */
export const AuthLayout = ({ children, footer }: AuthLayoutProps) => {
  const { t } = useTranslation();
  const { data: alive } = useGetAliveQuery();

  return (
    <div className="qz-auth">
      <div className="qz-auth-box">
        <div className="qz-auth-brand">
          <span className="qz-brand-mark" aria-hidden="true">
            ?
          </span>
          {t('nav.appName')}
          {alive && <span className="qz-env">{alive.envType}</span>}
        </div>
        <div className="qz-card">
          <div className="qz-card-body">{children}</div>
        </div>
        {footer && <div className="qz-auth-links">{footer}</div>}
      </div>
    </div>
  );
};

export default AuthLayout;
